/* eslint-disable no-console */
import { LoaderFunction } from 'react-router-dom';

import apiClient from 'src/api';
import {
  ContentfulInstructorLedTraining,
  ContentfulInstructorLedTrainingResponse,
  GET_INSTRUCTOR_LED_TRAINING,
} from 'src/graphql/queries/GetInstructorLedTraining';
import { fetchGraphQL } from 'src/services/contentful/client';

export interface SessionData {
  id: string;
  month: string;
  day: string;
  label: string;
  time: string;
}

export interface EnrollBannerData {
  meetingId: string;
  materialsLink: string;
  countdown: {
    days: number;
    hours: number;
  };
}

interface GetInstructorLedTrainingQueryVariables {
  slug: string;
  preview: boolean;
}

const getInstructorLedTrainingData = async (
  slug: string,
  preview: boolean,
): Promise<ContentfulInstructorLedTraining | undefined> => {
  try {
    const response = await fetchGraphQL<
      ContentfulInstructorLedTrainingResponse,
      GetInstructorLedTrainingQueryVariables
    >(GET_INSTRUCTOR_LED_TRAINING, {
      slug,
      preview,
    });

    return response.instructorLedTrainingCollection.items[0];
  } catch (error) {
    console.error('Error fetching ILT data:', error);

    return undefined;
  }
};

export interface Props {
  courseId: string;
  iltData?: ContentfulInstructorLedTraining;
  session: SessionData;
  enrollBanner: EnrollBannerData;
}

export const loader: LoaderFunction = async ({ params }): Promise<Props> => {
  const courseId = params.courseId ?? '';
  const instanceId = params.instanceId ?? '';
  const preview = false;

  const iltData = await getInstructorLedTrainingData(courseId, preview);

  // Check if user is enrolled in this specific session
  let isEnrolled = false;

  try {
    const res = await apiClient.adobe.getEnrollments({
      email: 'rknight@atlassian.com',
      aaid: '111',
    });

    if (res.data?.data) {
      const enrollment = res.data.data.find((item) => {
        if (item.relationships?.learningObject?.data?.id === courseId && item.id) {
          // Parse ID format: "course:12547259_15145914_30579649"
          const idParts = item.id.split(':')[1]?.split('_');
          const enrolledInstanceId = idParts?.[1];

          return enrolledInstanceId === instanceId;
        }

        return false;
      });

      isEnrolled = !!enrollment;
    }
  } catch (error) {
    console.error('Error checking enrollment:', error);
  }

  // TODO: Fetch actual session data from Adobe API using instanceId
  // Mock session data for now
  const session: SessionData = {
    id: instanceId,
    month: 'SEP',
    day: '25',
    label: 'Wednesday, October 29th',
    time: '8AM-10AM CST',
  };

  // Mock enroll banner data
  // Only return banner data if user is enrolled
  const enrollBanner: EnrollBannerData = isEnrolled
    ? {
        meetingId: 'abc-defg-hij',
        materialsLink: 'https://example.com/materials',
        countdown: {
          days: 5,
          hours: 12,
        },
      }
    : {
        meetingId: '',
        materialsLink: '',
        countdown: {
          days: 0,
          hours: 0,
        },
      };

  return {
    courseId,
    iltData,
    session,
    enrollBanner,
  };
};
